module.exports = "<p>{{ title }}</p>\n<p>{{ message }}</p>\n<button type=\"button\" mat-raised-button \n    (click)=\"dialogRef.close(true)\">OK</button>\n<button type=\"button\" mat-button \n    (click)=\"dialogRef.close(false)\">Cancel</button>\n"


//////////////////
// WEBPACK FOOTER
// c:/Dev/Angular/liceo/src/app/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/confirm-dialog/confirm-dialog.component.html
// module chunks = main